import { Config } from '../_config'
import { Environment } from '../_kernel/Environment'
import { BaseHeader } from './BaseHeader'

export class FactoryHeader {
  static create({ config }: { config: Config }) {
    return new FactoryHeader(config)
  }

  constructor(private config: Config) {}

  async header(): Promise<BaseHeader> {
    const isNode = Environment.create().isNode()

    return isNode
      ? (await import('./NodeHeader')).NodeHeader.create({ config: this.config })
      : (await import('./WindowHeader')).WindowHeader.create({ config: this.config })
  }
}
